import React from 'react'

import { PostalCode as CorePostalCode } from '@grandvisionhq/forms'
import { useIntl } from '@grandvisionhq/state'

import { isValidPostalCode } from '../../../util/form-validation'

export const PostalCode = ({ required }: { required?: boolean }) => {
  const { getLabel } = useIntl()

  return (
    <CorePostalCode
      label={getLabel('checkout.address.postalCode')}
      errorMessage={getLabel('checkout.address.postalCode.errorMessage')}
      validations={[isValidPostalCode]}
      required={required}
    />
  )
}
